<script lang="ts">
  import { Button, Icon } from '$shared/components';
  import UnionIcon from '$shared/images/union.svg';
  import LoadAnimate from '$shared/images/LoadAnimate.svg';

  interface Props {
    loading?: boolean;
    disabled?: boolean;
    onclick?: () => void;
  }

  let { loading = false, disabled = false, onclick }: Props = $props();
</script>

<Button disabled={disabled || loading} {onclick}>
  {#if loading}
    <span class="loader-icon">
      <img src={LoadAnimate} class="load-icon" alt="Loading" aria-hidden="true" width="16" />
    </span>
    Loading...
  {:else}
    <img src={UnionIcon} class="union-icon" alt="" aria-hidden="true" width="12" />
    Credential Providers
  {/if}
</Button>

<style>
  .union-icon {
    margin-right: 5px;
  }
  .loader-icon {
    margin-right: 3px;
  }
</style>
